import { brandTokens } from "./theme";

export function getSeverityTagColor(severity: "high" | "medium" | "low") {
  if (severity === "high") return "red";
  if (severity === "medium") return "gold";
  return "default";
}

export function getSeverityAccent(severity: "high" | "medium" | "low") {
  if (severity === "high") return brandTokens.colorError;
  if (severity === "medium") return brandTokens.colorWarning;
  return brandTokens.colorSuccess;
}

export const surfaceStyles = {
  subtleCard: {
    background: brandTokens.colorSurfaceAlt,
    borderRadius: brandTokens.radiusSm,
  },
  selectedCard: {
    background: "#fff4f1",
    border: `2px solid ${brandTokens.colorPrimary}`,
  },
};
